import React from 'react';
import './css/skill.css';

export default function Skill() {
  return (
    <div className="container skill mb-3" id="skills">
      <h1>Skills</h1>
      <div className="showingSkills row">
        <div className="col-md-4 mb-3">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title custom-title">Problem Solving </h5>
              <p className="card-text">
                Solved <b>600+</b> problems on various online judges.
              </p>
            </div>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <b>
                  <a
                    href="https://codeforces.com/profile/Raihanul786"
                    rel="noreferrer"
                    target="_blank"
                    style={{ textDecoration: 'none' }}
                  >
                    <i class="bi bi-link"></i> CodeForces:
                  </a>
                </b>
                <p>
                  <b>430+</b> problems.
                </p>
              </li>
              <li className="list-group-item">
                <b>
                  <a
                    href="https://www.beecrowd.com.br/judge/en/profile/225990"
                    rel="noreferrer"
                    target="_blank"
                    style={{ textDecoration: 'none' }}
                  >
                    <i class="bi bi-link"></i> beecrowd:
                  </a>
                </b>
                <p>
                  <b>100+</b> problems.
                </p>
              </li>
              <li className="list-group-item">
                <b>Language:</b> C, C++, JS, Python
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Frontend </h5>
              <p className="card-text">
                I have attached some frontend project at portfolio section.
                Generally I love to develope frontend through react.js , Some
                tools that I use regularly mentioned bellow.
              </p>
            </div>
            <ul className="list-group list-group-flush ">
              <li className="list-group-item">HTML,CSS,Bootstrap</li>
              <li className="list-group-item">React*</li>
              <li className="list-group-item">
                <b>OS:</b> Windows
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Backend</h5>
              <p className="card-text pb-5">
                I like to consider myself as MERN stack developer. Here are some
                of my tools that I use regularly.
              </p>
            </div>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">Express, Node.js</li>
              <li className="list-group-item">
                <b>Database:</b> NoSQL/MongoDB & MySQL
              </li>
              <li className="list-group-item">
                <b>Tools:</b> VS code
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
